import {
   FETCH_CLUE_ICONS,
} from "../constants/ActionTypes";

/*
 * Reducer for clue icons dynamically loaded from firestore
 */
export default function (state = null, action) {

   switch (action.type) {
      case FETCH_CLUE_ICONS:

         // if there is no new data, just return the existing state
         if (!action.payload) {
            return state;
         } else {
            return action.payload;
         }
      default:
         return state
   }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_clue_icons.js